import React, { useEffect, useState } from 'react';
import { Card, Switch, Typography, message } from 'antd';
import { AdminLayout } from '../../components/AdminLayout';
import { useTranslation } from '../../shared/hooks/useTranslation';
import style from './AdminSettings.module.scss';

const { Title, Text } = Typography;

const SERVICE_SHOW_BRACKETS_KEY = 'service_show_brackets';

export function AdminSettings() {
  const [showBrackets, setShowBrackets] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    setShowBrackets(localStorage.getItem(SERVICE_SHOW_BRACKETS_KEY) === '1');
  }, []);

  const handleToggle = (checked: boolean) => {
    setShowBrackets(checked);
    localStorage.setItem(SERVICE_SHOW_BRACKETS_KEY, checked ? '1' : '0');
    message.success(checked ? t.adminSettingsBracketsOn : t.adminSettingsBracketsOff);
  };

  return (
    <AdminLayout>
      <div className={style.container}>
        <Title level={4} style={{ fontSize: 22, fontWeight: 600 }}>{t.adminSettingsTitle}</Title>
        <Card className={style.card}>
          <div className={style.settingRow}>
            <div>
              <Text strong>{t.adminSettingsShowBrackets}</Text>
              <br />
              <Text type="secondary">{t.adminSettingsShowBracketsExample}</Text>
            </div>
            <Switch checked={showBrackets} onChange={handleToggle} />
          </div>
        </Card>
      </div>
    </AdminLayout>
  );
}
